import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo, useEffect } from 'react';
import MuiTypography from '@mui/material/Typography';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material';
import '../../Pagination/Pagination.js';
import PaginationIcon from '../../Pagination/PaginationIcon.js';

const Root = styled(MuiBox, { shouldForwardProp: prop => !['headerCount'].includes(prop) }) `
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  align-items: center;
  margin: ${({ theme }) => theme.spacing(6, 4, 2, 4)};
  grid-column-start: ${({ headerCount = 0 }) => headerCount + 1};
  justify-content: flex-${({ headerCount }) => (headerCount === 0 ? 'start' : 'end')};
`;
const _PaginationIcon = styled(PaginationIcon) `
  ${({ type }) => type === 'next' && `grid-column-start: 3`};
  justify-self: ${({ type }) => (type === 'previous' ? 'flex-start' : 'flex-end')};
`;
const MonthLabel = styled(MuiTypography, { shouldForwardProp: prop => !['headerCount'].includes(prop) }) `
  color: ${({ theme }) => theme.palette.N20.main};
  ${({ headerCount }) => headerCount === 1 && `grid-column-start: 2`};
`;
const RangeDateHeader = ({ monthDate, initialRangeStart, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled, customHeaderCount, prevHint, nextHint, locale, }) => {
    const monthLabel = useMemo(() => {
        return monthDate === null || monthDate === void 0 ? void 0 : monthDate.toLocaleString(locale, {
            month: 'long',
            year: 'numeric',
        });
    }, [monthDate, locale]);
    useEffect(() => {
        if (customHeaderCount === 0 && initialRangeStart) {
            const initialRangeMonth = initialRangeStart.getMonth();
            const currentMonth = monthDate.getMonth();
            if (initialRangeMonth !== currentMonth) {
                changeMonth(initialRangeMonth + 1);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (jsxs(Root, Object.assign({ headerCount: customHeaderCount, role: "date-picker-header", "data-testid": "range-date-picker-header" }, { children: [customHeaderCount === 0 && (jsx(_PaginationIcon, { hint: prevHint, type: "previous", onClick: decreaseMonth, disabled: prevMonthButtonDisabled })), jsx(MonthLabel, Object.assign({ headerCount: customHeaderCount, variant: "subtitle2" }, { children: monthLabel })), customHeaderCount === 1 && (jsx(_PaginationIcon, { hint: nextHint, type: "next", onClick: increaseMonth, disabled: nextMonthButtonDisabled }))] })));
};

export { RangeDateHeader as default };
//# sourceMappingURL=RangeDateHeader.js.map
